<div
  #card__container
  class="card__container"
  [ngClass]="order.status === orderStatus.CANCELLED && 'card__canceled'"
>
  <ul class="card__info width-columns-orders">
    <li class="card__checkbox">
      <div>
        <input
          class="checkbox"
          type="checkbox"
          [checked]="checked"
          (click)="toggleCheckbox()"
          [id]="order.id"
          [value]="order.id"
        />
        <label class="form-check-label" [for]="order.id"></label>
      </div>
    </li>
    <li class="card__date">
      <div>
        <time>{{ order.date | date : "dd/MM/yyyy" }}</time>
        <time class="strong-color">{{ order.date | date : "HH:mm" }}</time>
      </div>
    </li>
    <li class="card__client">
      <span>#{{ order.orderNumber }}</span>
      <span class="strong-color"
        >{{ order.metadata.user.customerName }}
        {{ order.metadata.user.customerLastName }}</span
      >
    </li>
    <li class="card__value">
      <span>{{ order.metadata.total | currency : "R$" }}</span>
      <div
        class="strong-color"
        (click)="toggleDetails($event)"
        style="cursor: pointer"
      >
        <span class="line" *ngIf="order.metadata.totalProducts === 1"
          >{{ order.metadata.totalProducts }} item</span
        >
        <span class="line" *ngIf="order.metadata.totalProducts > 1"
          >{{ order.metadata.totalProducts }} itens</span
        >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="chevron-down"
          class="svg-inline--fa fa-chevron-down fa-w-14"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
          ></path>
        </svg>
      </div>
    </li>
    <li class="card__payment">
      <span>{{ order.metadata.isDelivery ? "Na entrega" : "Ao retirar" }}</span>

      <!-- Bandeira para dinheiro -->
      <span
        class="payment-type-flag money"
        *ngIf="order.metadata.paymentMethod.name === 'dinheiro'"
      >
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1677_4882)">
            <path
              d="M7.188 15.188C5.76635 15.188 4.37663 14.7664 3.19456 13.9766C2.0125 13.1868 1.0912 12.0642 0.547157 10.7507C0.00311446 9.43731 -0.139232 7.99204 0.138119 6.59771C0.415469 5.20337 1.10006 3.92259 2.10532 2.91733C3.11058 1.91207 4.39136 1.22748 5.78569 0.95013C7.18003 0.67278 8.6253 0.815126 9.93873 1.35917C11.2522 1.90321 12.3748 2.82452 13.1646 4.00658C13.9544 5.18864 14.376 6.57836 14.376 8.00001C14.376 8.94396 14.1901 9.87865 13.8288 10.7507C13.4676 11.6228 12.9382 12.4152 12.2707 13.0827C11.6032 13.7502 10.8108 14.2796 9.93873 14.6409C9.06664 15.0021 8.13194 15.188 7.188 15.188ZM7.188 13.75C8.32553 13.7502 9.43756 13.4131 10.3835 12.7812C11.3294 12.1494 12.0666 11.2512 12.502 10.2003C12.9374 9.14939 13.0514 7.99297 12.8295 6.8773C12.6077 5.76162 12.0599 4.7368 11.2556 3.93244C10.4512 3.12809 9.4264 2.58034 8.31072 2.35847C7.19504 2.1366 6.03863 2.25057 4.98773 2.68598C3.93683 3.12138 3.03866 3.85865 2.40681 4.80455C1.77495 5.75045 1.43781 6.86249 1.438 8.00001C1.438 9.5251 2.04377 10.9877 3.12208 12.0662C4.20038 13.1447 5.66292 13.7507 7.188 13.751V13.75ZM4.672 9.43801H8.625C8.72035 9.43801 8.81179 9.40014 8.87921 9.33272C8.94663 9.2653 8.9845 9.17386 8.9845 9.07852C8.9845 8.98317 8.94663 8.89173 8.87921 8.82431C8.81179 8.75689 8.72035 8.71901 8.625 8.71901H5.751C5.50628 8.73316 5.26125 8.69717 5.03094 8.61326C4.80062 8.52935 4.58987 8.39928 4.4116 8.23102C4.23334 8.06276 4.09132 7.85987 3.99426 7.63478C3.89719 7.40969 3.84712 7.16714 3.84712 6.92201C3.84712 6.67689 3.89719 6.43434 3.99426 6.20925C4.09132 5.98416 4.23334 5.78127 4.4116 5.61301C4.58987 5.44476 4.80062 5.31468 5.03094 5.23077C5.26125 5.14686 5.50628 5.11087 5.751 5.12502H6.47V3.68702H7.907V5.12502H9.707V6.56301H5.751C5.65566 6.56301 5.56422 6.60089 5.4968 6.66831C5.42938 6.73573 5.3915 6.82717 5.3915 6.92252C5.3915 7.01786 5.42938 7.1093 5.4968 7.17672C5.56422 7.24414 5.65566 7.28202 5.751 7.28202H8.626C8.87072 7.26787 9.11575 7.30386 9.34607 7.38777C9.57639 7.47168 9.78714 7.60175 9.9654 7.77001C10.1437 7.93827 10.2857 8.14116 10.3827 8.36625C10.4798 8.59134 10.5299 8.83389 10.5299 9.07901C10.5299 9.32414 10.4798 9.56669 10.3827 9.79178C10.2857 10.0169 10.1437 10.2198 9.9654 10.388C9.78714 10.5563 9.57639 10.6863 9.34607 10.7703C9.11575 10.8542 8.87072 10.8902 8.626 10.876H7.907V12.312H6.469V10.875H4.669L4.672 9.43801Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1677_4882">
              <rect
                width="14.376"
                height="14.376"
                fill="white"
                transform="translate(0 0.812012)"
              />
            </clipPath>
          </defs>
        </svg>

        <p>{{ order.metadata.paymentMethod.name }}</p>
      </span>
      <!-- Bandeira para cartões de crédito -->
      <span
        class="payment-type-flag credit"
        *ngIf="order.metadata.paymentMethod.type.toLowerCase() === 'credit'"
      >
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1677_4877)">
            <path
              d="M15.997 4.48763V2.27976C15.997 1.32652 15.3843 0.501953 14.6015 0.501953H1.39162C0.64265 0.501953 -0.00390625 1.28165 -0.00390625 2.27976V4.49017L15.997 4.48763Z"
              fill="#2960F6"
            />
            <path
              d="M0 5.39648V11.7204C0 12.6736 0.612714 13.4982 1.39553 13.4982H14.6045C15.3534 13.4982 16 12.7185 16 11.7204V5.39648H0ZM14.6383 11.6806H10.2469V10.8137H14.6383V11.6806Z"
              fill="#2960F6"
            />
          </g>
          <defs>
            <clipPath id="clip0_1677_4877">
              <rect
                width="16"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>

        <p>{{ order.metadata.paymentMethod.name }}</p>
      </span>
      <!-- Bandeira para cartões de débito -->
      <span
        class="payment-type-flag debit"
        *ngIf="order.metadata.paymentMethod.type.toLowerCase() === 'debit'"
      >
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1677_4899)">
            <path
              d="M15.997 4.48763V2.27976C15.997 1.32652 15.3843 0.501953 14.6015 0.501953H1.39162C0.64265 0.501953 -0.00390625 1.28165 -0.00390625 2.27976V4.49017L15.997 4.48763Z"
              fill="#292F31"
            />
            <path
              d="M0 5.39648V11.7204C0 12.6736 0.612714 13.4982 1.39553 13.4982H14.6045C15.3534 13.4982 16 12.7185 16 11.7204V5.39648H0ZM14.6383 11.6806H10.2469V10.8137H14.6383V11.6806Z"
              fill="#292F31"
            />
          </g>
          <defs>
            <clipPath id="clip0_1677_4899">
              <rect
                width="16"
                height="13"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>

        <p>{{ order.metadata.paymentMethod.name }}</p>
      </span>
      <!-- Bandeira para voucher -->
      <span
        class="payment-type-flag voucher"
        *ngIf="order.metadata.paymentMethod.type.toLowerCase() === 'voucher'"
      >
        <svg
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 2.5C0 1.39543 0.895431 0.5 2 0.5H14C15.1046 0.5 16 1.39543 16 2.5V11.5C16 12.6046 15.1046 13.5 14 13.5H2C0.895431 13.5 0 12.6046 0 11.5V2.5ZM2 9C2 8.44772 2.44772 8 3 8H8C8.55229 8 9 8.44772 9 9C9 9.55229 8.55228 10 8 10H3C2.44772 10 2 9.55229 2 9ZM3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H12C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4H3Z"
            fill="#64BC0D"
          />
        </svg>

        <p>{{ order.metadata.paymentMethod.name }}</p>
      </span>

      <!-- Bandeira para pix -->
      <span
        class="payment-type-flag pix"
        *ngIf="order.metadata.paymentMethod.type.toLowerCase() === 'pix'"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6361 12.3959C12.3236 12.397 12.0139 12.3362 11.725 12.2169C11.4362 12.0976 11.1738 11.9222 10.9531 11.7009L8.52211 9.26892C8.43612 9.18659 8.32166 9.14062 8.20261 9.14062C8.08356 9.14062 7.9691 9.18659 7.88311 9.26892L5.44411 11.7079C5.2238 11.9301 4.96161 12.1063 4.67272 12.2265C4.38383 12.3466 4.07399 12.4083 3.76111 12.4079H3.28711L6.36711 15.4879C6.82905 15.9489 7.45501 16.2078 8.10761 16.2078C8.76022 16.2078 9.38616 15.9489 9.84811 15.4879L12.9341 12.4009L12.6361 12.3959Z"
            fill="white"
          />
          <path
            d="M3.76311 3.79917C4.07599 3.79872 4.38586 3.86035 4.67476 3.98051C4.96365 4.10067 5.22583 4.27696 5.44611 4.49917L7.88711 6.93517C7.97187 7.01987 8.08679 7.06744 8.20661 7.06744C8.32643 7.06744 8.44135 7.01987 8.52611 6.93517L10.9561 4.50517C11.1763 4.28278 11.4384 4.10637 11.7273 3.9862C12.0163 3.86603 12.3262 3.80449 12.6391 3.80517H12.9321L9.84611 0.719168C9.61757 0.49055 9.34623 0.309195 9.04759 0.185463C8.74895 0.0617312 8.42886 -0.00195312 8.10561 -0.00195312C7.78235 -0.00195312 7.46226 0.0617312 7.16362 0.185463C6.86498 0.309195 6.59365 0.49055 6.36511 0.719168L3.28711 3.79917H3.76311Z"
            fill="white"
          />
          <path
            d="M15.4818 6.36028L13.6168 4.49528C13.5749 4.51253 13.5301 4.52169 13.4848 4.52228H12.6368C12.1955 4.52344 11.7725 4.69882 11.4598 5.01028L9.02981 7.43928C8.81101 7.65771 8.51448 7.7804 8.20531 7.7804C7.89614 7.7804 7.59961 7.65771 7.38081 7.43928L4.94181 5.00128C4.62908 4.68992 4.20611 4.51455 3.76481 4.51328H2.72281C2.68 4.51235 2.63769 4.50388 2.59781 4.48828L0.722809 6.36028C0.261827 6.82222 0.00292969 7.44817 0.00292969 8.10078C0.00292969 8.75338 0.261827 9.37934 0.722809 9.84128L2.59581 11.7143C2.63561 11.6984 2.67797 11.6899 2.72081 11.6893H3.76281C4.20411 11.688 4.62708 11.5126 4.93981 11.2013L7.37881 8.76228C7.60168 8.55129 7.89691 8.4337 8.20381 8.4337C8.51071 8.4337 8.80594 8.55129 9.02881 8.76228L11.4588 11.1923C11.7715 11.5036 12.1945 11.679 12.6358 11.6803H13.4838C13.5291 11.6807 13.5739 11.6899 13.6158 11.7073L15.4808 9.84228C15.7094 9.61374 15.8908 9.34241 16.0145 9.04377C16.1382 8.74513 16.2019 8.42503 16.2019 8.10178C16.2019 7.77852 16.1382 7.45843 16.0145 7.15979C15.8908 6.86115 15.7094 6.58982 15.4808 6.36128"
            fill="white"
          />
        </svg>

        <p>{{ order.metadata.paymentMethod.name }}</p>
      </span>
    </li>
    <li class="card__delivery">
      <span>{{ order.metadata.isDelivery ? "Delivery" : "Retirar" }}</span>
      <span class="strong-color">
        <p [ngClass]="getTrackingClass(order.status)">
          {{ order.status | mountOrderStatus : order.metadata.isDelivery }}
        </p>
      </span>
    </li>
    <li class="card__actions">
      <a
        [routerLink]="['/private/dashboard/orders/details-order']"
        [queryParams]="{ orderId: order.id, userId: userId }"
      >
        <app-tooltip tip="Detalhes" class="action__details">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </app-tooltip>
      </a>

      <div *ngIf="!printConfig || !printConfig.status">
        <app-tooltip
          tip="Impressão desativada"
          *ngIf="order.status !== orderStatus.RECUSED"
          class="action__print"
        >
          <svg
            class="disabled"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.25 7H16.75V5C16.75 3 16 2 13.75 2H10.25C8 2 7.25 3 7.25 5V7ZM16 15V19C16 21 15 22 13 22H11C9 22 8 21 8 19V15H16Z"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 15H7M7 11H10M21 10V15C21 17 20 18 18 18H16V15H8V18H6C4 18 3 17 3 15V10C3 8 4 7 6 7H18C20 7 21 8 21 10Z"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </app-tooltip>
      </div>
      <div (click)="printOrder()" *ngIf="printConfig && printConfig.status">
        <app-tooltip
          tip="Imprimir"
          *ngIf="order.status !== orderStatus.RECUSED"
          class="action__print"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.25 7H16.75V5C16.75 3 16 2 13.75 2H10.25C8 2 7.25 3 7.25 5V7ZM16 15V19C16 21 15 22 13 22H11C9 22 8 21 8 19V15H16Z"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 15H7M7 11H10M21 10V15C21 17 20 18 18 18H16V15H8V18H6C4 18 3 17 3 15V10C3 8 4 7 6 7H18C20 7 21 8 21 10Z"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </app-tooltip>
      </div>
    </li>
  </ul>
  <div class="card__details-container card__details--hide">
    <table class="card__details">
      <thead>
        <tr class="card__details-header">
          <th>Item</th>
          <th style="margin-right: 3px">Qtd.</th>
          <th>Preço.</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="card__details-item"
          *ngFor="let product of order.metadata.products"
        >
          <ng-container *ngIf="!product.product.variation">
            <td>{{ product.product.name }}</td>
            <td>{{ product.quantity }}</td>
            <td style="text-align: center">
              {{ calcProductPriceWithComplements(product) | currency : "R$" }}
            </td>
            <td style="text-align: center">
              {{
                calcProductPriceWithComplementsWithQty(
                  product,
                  product.quantity
                ) | currency : "R$"
              }}
            </td>
          </ng-container>
          <ng-container *ngIf="product.product.variation">
            <td>
              {{ product.product.name }}
              <strong>({{ product.product.variation.name }})</strong>
            </td>
            <td>{{ product.quantity }}</td>
            <td style="text-align: center">
              {{ product.product.variation.price | currency : "R$" }}
            </td>
            <td style="text-align: center">
              {{
                product.product.variation.price * product.quantity
                  | currency : "R$"
              }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>
